import React from 'react';
import './CallForPaper27.css';
import Navbar from '../../components/navbar';
import PageHeader from '../../about/PageHeader';
import Footer from '../../components/Footer';

const CallForPaper27 = () => {
  return (
        <>
      <Navbar />


      <PageHeader
        title="Call for Paper"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Call for Paper" },
        ]}
      />
    <div className="icaim-page-container">


      <div className="icaim-content-wrapper">
        <p className="icaim-intro-text">
          We invite scholars, academicians, professionals, policy makers and other stakeholders to contribute to the international conference with papers that address themes mentioned above. The interested participants who wish to submit their papers are requested to follow the guidelines given below:
        </p>

        {/* Paper Guidelines Section */}
        <div className="icaim-section-block">
          <div className="icaim-section-header">
            <div className="icaim-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-svg-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            </div>
            <h2>Paper Guidelines</h2>
          </div>
          
          <div className="icaim-guidelines-content">
            <ul className="icaim-bullet-list icaim-grid-list">
              <li>Abstract should be about 250 words</li>
              <li>Maximum length of paper: 5000 words</li>
              <li>The paper must be in two column format</li>
              <li>Author names should be followed by their affiliation</li>
              <li>Font type: Times New Roman & Font size: 9 pt</li>
            </ul>
          </div>
        </div>

        {/* Submission Link Bar */}
        <div className="icaim-action-bar">
          <div className="icaim-action-left">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="icaim-action-icon">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
            </svg>
            <span className="icaim-action-text">The softcopy of paper should be submitted to :</span>
          </div>
          <div className="icaim-action-divider"></div>
          <div className="icaim-action-right">
            <a href="https://easychair.org/conferences/?conf=icaim2024" target="_blank" rel="noreferrer" className="icaim-link-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="icaim-link-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
              https://easychair.org/conferences/?conf=icaim2024
            </a>
          </div>
        </div>

        {/* Info & Extra Bullets */}
        <div className="icaim-info-bar">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-action-icon">
            <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
          </svg>
          <span className="icaim-action-text">
            For more information, visit <a href="http://www.icaim.in" className="icaim-text-link">www.icaim.in</a>
          </span>
        </div>

        <ul className="icaim-bullet-list" style={{ marginTop: '20px', marginBottom: '40px', paddingLeft: '10px' }}>
          <li>Paper will be published in conference proceedings having ISBN.</li>
          <li>Quality research papers will also be published in UGC cared, Scopus Indexed and peer reviewed Journals.</li>
        </ul>

        {/* Important Dates Section */}
        <div className="icaim-section-block">
          <div className="icaim-section-header">
            <div className="icaim-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-svg-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
              </svg>
            </div>
            <h2>Important Dates</h2>
          </div>

          <div className="icaim-dates-wrapper">
            <table className="icaim-dates-table">
              <tbody>
                <tr>
                  <td>Paper submission deadline</td>
                  <td>15th January, 2024</td>
                </tr>
                <tr>
                  <td>Acceptance notification</td>
                  <td>20th January, 2024</td>
                </tr>
                <tr>
                  <td>Camera ready submission</td>
                  <td>25th January, 2024</td>
                </tr>
                <tr>
                  <td>Last Date of registration</td>
                  <td>25th January, 2024</td>
                </tr>
                <tr>
                  <td>Conference Date</td>
                  <td>10th - 11th February, 2024</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
          <Footer />
    </>
  );
 
};

export default CallForPaper27;